import React, { useEffect } from "react";

const CountDown = () => {
  useEffect(() => {
    const form = document.querySelector("form");
    const choice = document.querySelector("input");
    const countdownDisplay = document.querySelector(".countdown-display");
    let totalSeconds;
    let interval;

    function countSeconds() {
      const minutes = Math.floor(totalSeconds / 60);
      // TotalSeconds modulo de 60 pour avoir le reste qui n'entre pas dans les minutes
      const seconds = totalSeconds % 60;

      // Pour mettre un 0 supplémentaire à 2:0
      const sec = seconds < 10 ? "0" + seconds : seconds;

      countdownDisplay.textContent = `${minutes} : ${sec}`;

      if (totalSeconds > 0) {
        totalSeconds--;
      } else {
        countdownDisplay.textContent = "C'est terminé !";
        // Pour éviter que ça se joue à l'infini
        clearInterval(interval);
      }
    }

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      // isNaN : is not a number
      if (isNaN(choice.value)) {
        alert("Veuillez saisir seulement des chiffres");
      } else {
        totalSeconds = choice.value * 60;
        // Pour recharger la page :
        choice.value = "";
        // Pour éviter la possibilité de jouer plusieurs setInterval en même temps
        clearInterval(interval);
        // Ici, je passe setInterval à la variable interval, ce qui me permet (plus haut) d'appliquer le clearInterval au setInterval ci-dessous
        interval = setInterval(countSeconds, 1000);
      }
    });
  });

  return (
    <div>
      <div className="page-container-countdown">
        <div className="countdown-container">
          <h2>Entrez le nombre de minutes ci-dessous</h2>
          <form id="form">
            <input
              type="number"
              min="1"
              max="99"
              size="1"
              maxLength="2"
              id="choice"
              className="hover"
            />
            <input id="start" type="submit" value="GO" className="hover" />
          </form>

          <div className="countdown-display" id="countdownDisplay"></div>
        </div>
      </div>
    </div>
  );
};

export default CountDown;
